import styled from '@emotion/styled';

const RestaurantButton = styled.button`
  border-radius: 18px;
  padding: 10px 23px;
  font-size: 3rem;
  background-color: #fff;
  color: #FF5F00;
  margin: 5px;
  font-weight: 700;
    &:hover{
      border-radius: 18px;
      opacity:0.8;
    }
`;

export default RestaurantButton;
